import { Box, Typography, Button } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface Props {
  onContactAdmin?: () => void;
}

export default function NoCompanyAccess({ onContactAdmin }: Props) {
  const { t } = useAppTranslation("common");
  
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 3,
      }}
    >
      <Box sx={{ maxWidth: 480 }}>

        <BusinessIcon
          sx={{
            fontSize: 64,
            color: "text.secondary",
            opacity: 0.6,
            mb: 2,
          }}
        />

        <Typography variant="h5" fontWeight={600}>
          {t("Brak przypisanych firm")}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 2 }}
        >
          {t("Nie masz jeszcze przypisanych dostępów do żadnej firmy.")}
          {t("Skontaktuj się z administratorem systemu w celu uzyskania dostępu.")}
        </Typography>

        {onContactAdmin && (
          <Button
            variant="outlined"
            sx={{ mt: 3 }}
            onClick={onContactAdmin}
          >
            {t("Skontaktuj się z administratorem")}
          </Button>
        )}
      </Box>
    </Box>
  );
}
